// get the message depending on status
export function filterMessageByStatus(
  message: string,
  status: number,
  statusToCompare: number | number[],
  defaultMessage:
    | string
    | null = 'An error occurred. The service might be unavailable.'
): string | undefined {
  if (typeof statusToCompare === 'number') {
    statusToCompare = [statusToCompare];
  }
  return statusToCompare.includes(status)
    ? message
    : defaultMessage || undefined;
}
